module.exports = "<ng-transclude></ng-transclude>\n\n<div class=\"am4-sticky-footer am4-sticky-footer--infinite-scroll\" ng-class=\"{\n  'am4-sticky-footer--hidden': infiniteScrollFooterCtrl.infiniteScrollFooterHidden,\n  'am4-sticky-footer--at-bottom am4-sticky-footer--infinite-scroll-at-bottom': infiniteScrollFooterCtrl.infiniteScrollFooterAtBottom\n}\">\n    <div class=\"am4-sticky-footer__content\">\n        <div class=\"am4-sticky-footer__content__container\"></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/infiniteScrollFooter.html
// module id = 391
// module chunks = 14